import { get } from '../helpers/axios';

export function search(searchString) {
  return get('/registered_apps', { params: { search: searchString } });
}
